
import React, { useState, useEffect } from "react";
import { Row, Col, Dropdown } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import Loader from "../../components/Loader/Loader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../assets/css/brand.css";
import DeleteWarningMdl from "../../components/common/DeleteWarningMdl";
import { deleteStaffApi, getAllStaffApi } from "../../../services/apis/EventMangement/EventStaffApi";
import { useNavigate } from "react-router-dom";

const theadData = [
    { heading: "S.No.", sortingVale: "sno" },
    { heading: "Name", sortingVale: "name" },
    { heading: "Phone", sortingVale: "phone" },
    { heading: "Status", sortingVale: "status" },
    { heading: "Block/Unblock", sortingVale: "block_unblock" },
    { heading: "Action", sortingVale: "action" },
];

const AllStaff = () => {
    const navigate = useNavigate();
    const [sort, setSortata] = useState(10);
    const [loading, setLoading] = useState(false);

    const [allStaffList, setAllStaffList] = useState([]);
    const [showDeleteMdl, setShowDeleteMdl] = useState(false);
    const [deleteTableDataId, setDeleteTableDataId] = useState("");



    const getAllStaffList = async () => {
        setLoading(true);
        try {
            const response = await getAllStaffApi();
            setAllStaffList(response?.data?.data)
        } catch (error) {
            console.error("Error fetching cuisines:", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getAllStaffList();
    }, []);



    const handleDeleteSubmit = async () => {
        try {
            const res = await deleteStaffApi(deleteTableDataId);
            if (res.status === 200) {
                toast.success(res?.data?.message); // Display success message
                getAllStaffList();
                setDeleteTableDataId("");
                setShowDeleteMdl(false);
            } else {
                toast.error(
                    res?.data?.message || "Something went wrong. Please try again."
                );
            }
        } catch (err) {
            console.log(err);
        }
    };


    const handleEditStaff = (id) => {
        navigate(`/edit-agency-staff/${id}`);
    };

    const handleDeleteStaff = (id) => {
        setDeleteTableDataId(id);
        setShowDeleteMdl(true);
    };

    return (
        <>
            <DeleteWarningMdl title={"table data"} showDeleteMdl={showDeleteMdl} setShowDeleteMdl={setShowDeleteMdl}
                setDeleteTableDataId={setDeleteTableDataId} handleDeleteSubmit={handleDeleteSubmit} />

            <ToastContainer />

            <Loader visible={loading} />

            <PageTitle
                activeMenu={"Staff"}
                motherMenu={"Home"}
                motherMenuLink={"/dashboard"}
            />

            <Row>
                <Col lg={12}>
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Staff List</h4>

                            {/* <button className="btn" style={{ padding: "8px", border: "1px solid #6a73fa", color: "#6a73fa" }} ></button> */}
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <div id="holidayList" className="dataTables_wrapper no-footer">
                                    <div className="justify-content-between d-sm-flex">
                                        <div className="dataTables_length">
                                            <label className="d-flex align-items-center">
                                                Show
                                                <Dropdown className="search-drop">
                                                    <Dropdown.Toggle as="div" className="search-drop-btn">
                                                        {sort}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={() => setSortata("2")}>
                                                            2
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("5")}>
                                                            5
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("10")}>
                                                            10
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("15")}>
                                                            15
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("20")}>
                                                            20
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                entries
                                            </label>
                                        </div>
                                        <div className="dataTables_filter">
                                            <label>
                                                Search :
                                                <input
                                                    type="search"
                                                    className=""
                                                    placeholder=""
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <table id="example4" className="display dataTable no-footer w-100">
                                        <thead>
                                            <tr>
                                                {theadData?.map((item, ind) => {
                                                    return (
                                                        <th key={ind}>
                                                            {item.heading}
                                                            <span>
                                                                <i
                                                                    className="fa fa-arrow-down ms-2 fs-12"
                                                                    style={{ opacity: "0.7" }}
                                                                />

                                                            </span>
                                                        </th>
                                                    );
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {allStaffList?.map((data, ind) => (
                                                <tr key={ind}>
                                                    <td>
                                                        {ind + 1}
                                                    </td>
                                                    <td className="d-flex align-items-center gap-2">
                                                        {data?.username}
                                                    </td>




                                                    <td>
                                                        {data.phone}
                                                    </td>


                                                    <td>

                                                    </td>

                                                    <td>

                                                    </td>

                                                    <td>
                                                        <button className="btn btn-xs sharp btn-primary me-1"
                                                            onClick={() => handleEditStaff(data?._id)}
                                                        >
                                                            <i className="fa fa-pencil" />
                                                        </button>

                                                        <button className="btn btn-xs sharp btn-danger"
                                                            onClick={() => handleDeleteStaff(data?._id)}
                                                        >
                                                            <i className="fa fa-trash" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default AllStaff;
